// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"g2-z","displaySixCardTiles":"h2-z"};